<template>
  <div class="product-search">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <b-link block v-b-toggle.search-box variant="info"><strong>詳細検索</strong></b-link>
        </b-card-header>
        <b-collapse id="search-box" visible>
          <b-card-body>
            <b-form-group label="公開日:" label-cols-md="2" label-align-md="right">
              <b-input-group>
                <b-form-input type="date" v-model="conditions.published_at_start" />
                <b-input-group-text>～</b-input-group-text>
                <b-form-input type="date" v-model="conditions.published_at_end" />
              </b-input-group>
            </b-form-group>
            <b-form-group label="ユーザー:" label-cols-md="2" label-align-md="right">
              <b-form-checkbox-group
                v-model="conditions.users"
                buttons
                button-variant="outline-primary"
              >
                <b-form-checkbox value="my">自身のみ</b-form-checkbox>
                <b-form-checkbox value="other">自身以外</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="ステータス:" label-cols-md="2" label-align-md="right">
              <b-form-checkbox-group
                v-model="conditions.status"
                buttons
                button-variant="outline-primary"
              >
                <b-form-checkbox value="draft">下書き</b-form-checkbox>
                <b-form-checkbox value="public">公開中</b-form-checkbox>
                <b-form-checkbox value="finish">済</b-form-checkbox>
                <b-form-checkbox value="cancel">取消</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="種別:" label-cols-md="2" label-align-md="right">
              <b-form-checkbox-group
                v-model="conditions.type"
                buttons
                button-variant="outline-primary"
              >
                <b-form-checkbox value="sell">売りたい</b-form-checkbox>
                <b-form-checkbox value="buy">買いたい</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
            <b-form-group label="シリアルNo.:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.id" placeholder="シリアルNo." />
            </b-form-group>
            <b-form-group label="メーカー名:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.maker" placeholder="メーカー名" />
            </b-form-group>
            <b-form-group label="商品名:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.name" placeholder="商品名" />
            </b-form-group>
            <b-form-group label="CAS No.:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.cas_no" placeholder="CAS No." />
            </b-form-group>
            <b-form-group label="FEMA No.:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.fema_no" placeholder="FEMA No." />
            </b-form-group>
            <b-form-group label="入目:" label-cols-md="2" label-align-md="right">
              <b-input-group append="kg">
                <b-form-input v-model="conditions.pieces" placeholder="入目" />
              </b-input-group>
            </b-form-group>
            <b-form-group label="数量:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.nums" placeholder="数量" />
            </b-form-group>
            <b-form-group label="メモ欄:" label-cols-md="2" label-align-md="right">
              <b-form-input v-model="conditions.synonym" placeholder="メモ欄" />
            </b-form-group>
          </b-card-body>
          <b-card-footer>
            <b-button type="submit" variant="primary">検索</b-button>
            <b-button type="reset" variant="outline-primary">リセット</b-button>
          </b-card-footer>
        </b-collapse>
      </b-card>
    </b-form>
  </div>
</template>

<script>
let defaultConditions = {
  published_at_start: '',
  published_at_end: '',
  users: ['my', 'other'],
  status: ['draft', 'public', 'finish', 'cancel'],
  type: ['sell', 'buy'],
  id: '',
  maker: '',
  name: '',
  cas_no: '',
  fema_no: '',
  pieces: '',
  nums: '',
  synonym: '',
};

export default {
  name: 'ProductSearch',

  data() {
    return {
      conditions: Object.assign({}, defaultConditions),
    };
  },

  methods: {
    onSubmit(evt) {
      let options = {
        limit: this.$store.state.products.limit,
        page: 1,
        sortBy: this.$store.state.products.sortBy,
        sortDesc: this.$store.state.products.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('products/searchList', options);
    },

    onReset(evt) {
      this.conditions = Object.assign({}, defaultConditions);
      let options = {
        limit: this.$store.state.products.limit,
        page: 1,
        sortBy: this.$store.state.products.sortBy,
        sortDesc: this.$store.state.products.sortDesc,
        conditions: this.conditions,
      };
      this.$store.dispatch('products/searchList', options);
    },
  },
};
</script>

<style scoped>
</style>
